import { ConstantItems } from "@constants/shared";
import { Constants } from "@constants/shared";
import { CommItem } from "@app/communications/Communication";
import * as angular from "angular";

export class CommsRepo {
  static $inject = ["$http", "config"];

  constructor(
    private $http: angular.IHttpService,
    private config: ConstantItems,
    private configConstants: Constants
  ) {}
  getComms() {
    return this.$http
      .get(`${this.config.fileUrl}/communication`)
      .then((resp) => resp.data as CommItem[]);
  }

  saveComm(message, type, file) {
    const formData: FormData = new FormData();
    if (file) {
      formData.append("file", file, file.name);
    }

    return this.$http
      .post(
        `${this.config.fileUrl}/communication/${message}/${type}`,
        formData,
        {
          headers: {
            "Content-Type": undefined,
          },
          transformRequest: angular.identity,
        }
      )
      .then((resp) => resp.data as any);
  }

  updateCommActive(comm) {
    return this.$http
      .put(`${this.config.fileUrl}/communication/${comm.id}/${comm.active}`, {})
      .then((resp) => resp.data as any);
  }
}



// WEBPACK FOOTER //
// ./src/services/communications.repo.ts